module.exports = __webpack_public_path__ + "img/edit.894d894c.svg";